/**
 * LeagueNotification - Componente Presentacional
 * 
 * Componente que muestra notificaciones emergentes con auto-cierre.
 * Posicionado en la esquina superior derecha de la pantalla.
 * Se auto-cierra después de 20 segundos si el mensaje está presente.
 * 
 * @component
 * @param {Object} props - Props del componente
 * @param {string} props.message - Texto del mensaje a mostrar. Si está vacío, no renderiza nada.
 * @param {string} props.type - Tipo de notificación: 'success' (verde) o 'error' (rojo)
 * @param {Function} props.onClose - Callback ejecutado cuando la notificación debe cerrarse
 * @returns {JSX.Element|null} Elemento de notificación o null si no hay mensaje
 * 
 * Estilos CSS:
 * - notification-success: Fondo verde (#4caf50), borde izquierdo en verde oscuro
 * - notification-error: Fondo rojo (#f44336), borde izquierdo en rojo oscuro
 * 
 * Comportamiento:
 * - No se renderiza si message está vacío
 * - Auto-cierra después de 20 segundos (20000ms)
 * - Limpia el timer al desmontar o si el mensaje cambia
 * - Animación de entrada suave (slideDown)
 */

import { useEffect } from 'react';

export default function LeagueNotification({ message, type, onClose }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className={`notification notification-${type}`}>
      {message}
    </div>
  );
}